import type { VoidFunctionComponent } from 'react';

import LogoUpload from '../../LogoUpload';
import Section from '../../shared/settings/SettingsPageSection';

type Props = {
  fileUrl: string;
  setFile: (file: File) => void;
  unsetFile: () => void;
  handleImgError: () => void;
};

/**
 * Shared logo upload section for report settings pages.
 * Used by both the project and release group report settings pages.
 */
export const Logo: VoidFunctionComponent<Props> = ({ fileUrl, setFile, unsetFile, handleImgError }) => (
  <Section>
    <Section.Left heading="Logo">
      <Section.Paragraph>
        Upload the logo that will appear on the cover and header of your reports. This is a global setting and
        will be applied to all projects and release groups in your organization.
      </Section.Paragraph>
    </Section.Left>
    <Section.Right>
      <LogoUpload fileUrl={fileUrl} setFile={setFile} unsetFile={unsetFile} handleImgError={handleImgError} />
    </Section.Right>
  </Section>
);
